export const TRANSACTIONS = [
    {
        energyHumanReadable: "24.01 kWh",
        durationTime: "07:00:29",
        incomeHumanReadable: "R$ 32.95"
    },
    {
        energyHumanReadable: "0.01 kWh",
        durationTime: "07:00:29",
        incomeHumanReadable: "R$ 32.95"
    },
    {
        energyHumanReadable: "0.01 kWh",
        durationTime: "07:00:29",
        incomeHumanReadable: "R$ 32.95"
    },
    {
        energyHumanReadable: "0.01 kWh",
        durationTime: "07:00:29",
        incomeHumanReadable: "R$ 45.95"
    },
    {
        energyHumanReadable: "0.01 kWh",
        durationTime: "07:00:29",
        incomeHumanReadable: "R$ 32.95"
    },
    {
        energyHumanReadable: "0.01 kWh",
        durationTime: "07:00:29",
        incomeHumanReadable: "R$ 45.95"
    },
    {
        energyHumanReadable: "0.01 kWh",
        durationTime: "07:00:29",
        incomeHumanReadable: "R$ 45.95"
    },
]